import { useRef, useMemo } from "react";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import {
  MainInfoContentItemInput,
  MainInfoSectionItem,
  MainInfoSectionWrapper,
  MainInfoWrapper,
} from "../main-info/styles/main-info.style";
import { usePosterContext } from "../../../../context/poster-context";
import { EditLine } from "../../styles";
import { NoticeEditorWrapper } from "./styles/notice.style";
var Size = Quill.import("attributors/style/size") as any;

const Notice = () => {
  const { noticeSection, setNoticeSection, notice, setNotice } =
    usePosterContext();
  const editorRef = useRef<ReactQuill>(null);

  Size.whitelist = [
    "8px",
    "9px",
    "10px",
    "11px",
    "12px",
    "13px",
    "14px",
    "15px",
    "16px",
    "17px",
    "18px",
    "19px",
    "20px",
  ];
  Size.defaultSize = "16px";
  ReactQuill.Quill.register(Size, true);

  // React Quill 모듈 설정
  const modules = {
    toolbar: [
      [{ size: Size.whitelist }],
      [{ color: [] }, { background: [] }],
      ["bold", "italic", "underline", "strike"],
      ["image"],
    ],
  };

  const formats = [
    "size",
    "bold",
    "color",
    "background",
    "italic",
    "underline",
    "strike",
    "image",
  ];

  // React Quill에 전달할 값: HTML 형식이면 그대로, \n이 있으면 <br>로 변환
  const quillValue = useMemo(() => {
    if (!notice) return "";
    // 이미 HTML 태그가 있으면 그대로 사용
    if (notice.includes("<") || notice.includes(">")) {
      return notice;
    }
    // \n을 <br>로 변환
    return notice.replace(/\n/g, "<br>");
  }, [notice]);

  const handleChange = (content: string) => {
    // React Quill에서 나온 HTML을 저장
    setNotice(content);
  };

  return (
    <MainInfoWrapper>
      <MainInfoSectionWrapper>
        <MainInfoSectionItem>
          <div className="label">섹션명</div>
          <MainInfoContentItemInput
            value={noticeSection}
            onChange={(e) => setNoticeSection(e.target.value)}
          />
        </MainInfoSectionItem>
      </MainInfoSectionWrapper>
      <EditLine style={{ marginBottom: "30px" }} />
      <NoticeEditorWrapper>
        <ReactQuill
          ref={editorRef}
          theme="snow"
          value={quillValue}
          onChange={handleChange}
          modules={modules}
          formats={formats}
          placeholder="공지사항을 입력하세요..."
        />
      </NoticeEditorWrapper>
    </MainInfoWrapper>
  );
};

export default Notice;
